import InvestmentDetailsPage from "domains/liquidity/pages/InvestmentDetailsPage/InvestmentDetailsPage";

export default InvestmentDetailsPage;
